export const COLUMNS = [
    {
      Header: "S No",
      accessor: "serialNumber", // Matches the database field
    },
    {
      Header: "நாள்",
      accessor: "dayOfTheWeek", // Matches the database field
    },
    {
      Header: "நேரம்",
      accessor: "numericTime", // Matches the database field
    },
    {
      Header: "இடம்",
      accessor: "place", // Matches the database field
    },
    {
      Header: "பேச்சாளர்",
      accessor: "speaker", // Matches the database field
    },
  ];